"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTextboxPropertySelector = void 0;
var react_1 = require("react");
var property_1 = require("@promaster-sdk/property");
function useTextboxPropertySelector(_a) {
    var propertyName = _a.propertyName, propertyValueSet = _a.propertyValueSet, onValueChange = _a.onValueChange, readOnly = _a.readOnly, debounceTime = _a.debounceTime;
    var debouncedOnValueChange = react_1.useCallback(debounce(function (newValue) { return onValueChange(newValue); }, debounceTime), [onValueChange, debounceTime]);
    var value = property_1.PropertyValueSet.getText(propertyName, propertyValueSet);
    var _b = react_1.useState(value || ""), myState = _b[0], setMyState = _b[1];
    return {
        getInputProps: function () { return ({
            value: myState,
            readOnly: readOnly,
            onChange: function (e) {
                var newStringValue = e.target.value;
                setMyState(newStringValue);
                debouncedOnValueChange(property_1.PropertyValue.create("text", newStringValue));
            },
        }); },
    };
}
exports.useTextboxPropertySelector = useTextboxPropertySelector;
// (From underscore.js)
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debounce(func, wait, immediate) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var timeout;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var context = this; //eslint-disable-line
        var args = arguments; //eslint-disable-line
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
//# sourceMappingURL=use-textbox-property-selector.js.map